import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiToggleRight, FiToggleLeft, FiShield, FiSmartphone, FiBell, FiTerminal } = FiIcons;

export default function Settings() {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="max-w-2xl mx-auto space-y-8"
    >
      <header className="mb-8">
        <h2 className="text-3xl font-bold text-neutral-100">System Config</h2>
        <p className="text-neutral-400 mt-1 font-mono text-sm">Manage terminal preferences</p>
      </header>

      <div className="space-y-6">
        {/* Section 1 */}
        <div className="bg-neutral-900/30 border border-neutral-800 rounded-2xl overflow-hidden">
          <div className="p-4 border-b border-neutral-800 bg-neutral-950/50">
            <h3 className="font-mono text-xs uppercase tracking-widest text-emerald-400 flex items-center gap-2">
              <SafeIcon icon={FiBell} /> Notifications
            </h3>
          </div>
          <div className="p-2">
            {[
              { label: 'Pre-departure Warnings', active: true },
              { label: 'Weather Anomalies', active: true },
              { label: 'Weekly Recap Digest', active: false },
            ].map((setting, i) => (
              <div key={i} className="flex justify-between items-center p-4 hover:bg-neutral-800/30 rounded-xl transition-colors">
                <span className="text-sm text-neutral-300">{setting.label}</span>
                <SafeIcon 
                  icon={setting.active ? FiToggleRight : FiToggleLeft} 
                  className={`text-2xl ${setting.active ? 'text-emerald-500' : 'text-neutral-600'}`} 
                />
              </div>
            ))}
          </div>
        </div>

        {/* Section 2 */}
        <div className="bg-neutral-900/30 border border-neutral-800 rounded-2xl overflow-hidden">
          <div className="p-4 border-b border-neutral-800 bg-neutral-950/50">
            <h3 className="font-mono text-xs uppercase tracking-widest text-neutral-400 flex items-center gap-2">
              <SafeIcon icon={FiTerminal} /> Interface
            </h3>
          </div>
          <div className="p-2">
            <div className="flex justify-between items-center p-4">
              <span className="text-sm text-neutral-300">Theme</span>
              <span className="text-xs font-mono px-2 py-1 bg-neutral-800 text-neutral-400 rounded">Subway Dark (Locked)</span>
            </div>
            <div className="flex justify-between items-center p-4">
              <span className="text-sm text-neutral-300">Data Density</span>
              <select className="bg-neutral-950 border border-neutral-700 text-neutral-300 text-xs font-mono rounded px-2 py-1 outline-none focus:border-emerald-500">
                <option>Compact</option>
                <option>Comfortable</option>
              </select>
            </div>
          </div>
        </div>
        
        {/* About Module */}
        <div className="mt-12 p-6 bg-neutral-950 border border-neutral-800/50 rounded-2xl text-center">
            <div className="inline-flex p-3 bg-neutral-900 rounded-xl mb-4 border border-neutral-800">
                <SafeIcon icon={FiShield} className="text-2xl text-neutral-500" />
            </div>
            <h4 className="text-neutral-200 font-medium mb-1">CalmCommute System</h4>
            <p className="text-xs text-neutral-500 font-mono mb-4">Build 2.4.9 // Neural Nav Engine active</p>
            
            <div className="pt-4 border-t border-neutral-800/50">
               <p className="text-xs text-neutral-600 font-mono uppercase tracking-widest">
                Made by LingLink AI and DigLab AI
              </p>
            </div>
        </div>

      </div>
    </motion.div>
  );
}